(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.cardsCarousel = {
    attach: function attach(context, settings) {

      $('[data-carousel-id]').each(function () {
        const uuid = $(this).data('carousel-id');

        const carouselData = drupalSettings?.planisware?.carousel_card;
        const config = carouselData[uuid];
        const autoplay = config.autoplay?.[0]?.value ?? 0;
        const timeout = config.timeout?.[0]?.value ?? 5000;
        const pauseOnHover = config.pause_on_hover?.[0]?.value ?? 0;

        var autoplayvalue = false;
        var pauseonhovervalue = false;

        if (autoplay == 1) {
          autoplayvalue = true;
        }

        if (pauseOnHover == 1) {
          pauseonhovervalue = true;
        }
      $(this).find('.card-carousel').owlCarousel({
        autoplay: autoplayvalue,
        loop: true,
        autoplayTimeout: timeout,
        margin: 0,
        autoplayHoverPause: pauseonhovervalue,
        responsiveClass: true,
        nav: true,
        responsive:{
          0:{
              items: 1,
          },
          700:{
            items: 2,
          },
          1140:{
            items: 3,
          }
        }
      })
      });
    }
  };
})(jQuery, Drupal, drupalSettings);
